import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { DateRangePicker, Range } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import './IdmDateRangePicker.css';
import DesignButton from 'components/button/DesignButton';
import DesignInput from 'components/input/DesignInput';

export interface IIdmDateRangePickerProps {
  onConfirmedDate: (startDate: Date, endDate: Date) => void;
  fieldLabel: string;
}

export function IdmDateRangePicker({
  onConfirmedDate,
  fieldLabel,
}: IIdmDateRangePickerProps) {
  const refOne = useRef(null);
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState<Range[]>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);

  useEffect(() => {
    if (range[0].endDate && range[0].endDate > new Date()) {
      range[0].endDate = new Date();
      setRange(range);
    }
  }, [range]);

  const hideOnEscape = (e: any) => {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', hideOnEscape, true);
  }, []);

  const confirmDates = () => {
    setOpen(false);
    onConfirmedDate(range[0].startDate!, range[0].endDate!);
  };

  return (
    <div className="mb-4">
      <label
        className="mb-2 block text-xs font-bold uppercase tracking-wide"
        htmlFor="username"
      >
        {fieldLabel}
      </label>
      {range[0].startDate && range[0].endDate && (
        <DesignInput
          name="dateInput"
          onChanceHandler={() => {}}
          type="string"
          value={`${format(range[0]?.startDate, 'MM/dd/yyyy')} - ${format(
            range[0]?.endDate,
            'MM/dd/yyyy',
          )}`}
          step={undefined}
          onClick={() => setOpen((isOpen) => !isOpen)}
        />
      )}
      <div ref={refOne} className="absolute z-50 flex flex-col">
        {open && (
          <>
            <DateRangePicker
              onChange={(item) => setRange([item.selection])}
              editableDateInputs
              moveRangeOnFirstSelection={false}
              ranges={range}
              months={2}
              direction="horizontal"
              maxDate={new Date()}
              color="#b02025"
              weekStartsOn={1}
              rangeColors={['#b02025']}
            />
            <DesignButton
              onClickHandler={confirmDates}
              className="bg-white dark:bg-design-black"
            >
              Confirm dates
            </DesignButton>
          </>
        )}
      </div>
    </div>
  );
}
